exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ input[type='checkbox'] {\n  display: block !important; }\n\n:host /deep/ input[type='radio'] {\n  display: block !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/announcementItems/announcementItems.component.scss
// module id = ../../../../../src/app/base/backoffice/announcementItems/announcementItems.component.scss
// module chunks = main